import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "../";

class FlaggableHierarchyTreeItem extends React.Component {
  get paddingLeft() {
    return `${this.props.indentSize * this.props.layer + 24}px`;
  }

  render() {
    return (
      <div
        className="tree-item clickable hoverable my-1 w-100"
        data-is-selected={this.props.isSelected}
        id={this.props.id}
        onClick={this.props.onClick}
        style={{
          paddingLeft: this.paddingLeft,
        }}
      >
        <span
          className="pl-1 pt-1 pb-1"
          style={{
            ...this.props.style,
            display: "inline-block",
            fontWeight: this.props.isSelected ? 900 : 400,
            minHeight: `${this.props.indentSize}px`,
          }}
        >
          <Checkbox
            className={this.props.checkboxClassName}
            checked={this.props.isSelected}
            id={this.props.id}
            label={this.props.label}
          />
        </span>
      </div>
    );
  }
}

FlaggableHierarchyTreeItem.propTypes = {
  checkboxClassName: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  indentSize: PropTypes.number,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  layer: PropTypes.number,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

FlaggableHierarchyTreeItem.defaultProps = {
  indentSize: 16,
  layer: 0,
};

export default FlaggableHierarchyTreeItem;
